export const DEMO_ADMIN_EMAIL = 'abdallahmaddeh1@gmail.com';
export const DEMO_ADMIN_MESSAGE = 'Désolé tu es dans le mode admin démonstration';

export function isDemoAdmin(user) {
  return Boolean(user?.readOnly || user?.read_only || user?.email?.toLowerCase() === DEMO_ADMIN_EMAIL);
}
